export const RELATED_TO_TYPES_RESET_STATE = 'RELATED_TO_TYPES_RESET_STATE';
export const RELATED_TO_TYPES_CURRENT_ITEM = 'RELATED_TO_TYPES_CURRENT_ITEM';
 
export const RELATED_TO_TYPES_REQUEST_LOADING = 'RELATED_TO_TYPES_REQUEST_LOADING';
export const RELATED_TO_TYPES_REQUEST_SUCCESS = 'RELATED_TO_TYPES_REQUEST_SUCCESS';
export const RELATED_TO_TYPES_REQUEST_FAILED = 'RELATED_TO_TYPES_REQUEST_FAILED';
 
export const RELATED_TO_TYPES_CURRENT_ACTION = 'RELATED_TO_TYPES_CURRENT_ACTION';
export const RELATED_TO_TYPES_RESET_ACTION = 'RELATED_TO_TYPES_RESET_ACTION';